import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyC9RX_o0eK2XXBfaH0UGDbINHxxmPGv26k",
    authDomain: "simly-almosafer-campaign.firebaseapp.com",
    projectId: "simly-almosafer-campaign",
    storageBucket: "simly-almosafer-campaign.firebasestorage.app",
    messagingSenderId: "681590026724",
    appId: "1:681590026724:web:ab682f80d72375288517f1",
    measurementId: "G-VWF8Y070TN"
};

export const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const analytics = getAnalytics(app);
